import React from 'react';
import VimeoEmbed from '../../Shared/VimeoEmbed'
import styles from './StoryCards.module.scss';
import Img from 'gatsby-image'

const StoryCards = (props) => (
  <div>
      {props.successStoryCards.map((story, i) =>
        <div className={styles.Story} key={i}>
          <div className={styles.Story__top}>
            <div className={styles.Story__Left}>
              <h2>{story.name}</h2>
              <div className={styles.Story__Left__Image}>
                <Img sizes={story.profileImage.sizes} alt={story.profileImage.title} className={`profileImage`}/>
              </div>
            </div>
            <div className={styles.Story__right}>
              <div className={styles.stats}>
                {story.stats.map((stat, iterator) =>
                  <p className={styles.stats__item} key={iterator}><strong>{stat.title}</strong> {stat.text.text}</p>
                )}
              </div>
              <div className={styles.logos}>
                {story.logos.map((logo, iterator) =>
                  <Img sizes={logo.sizes} alt={logo.title} key={iterator} />
                )}
              </div>
              <p className={styles.Story__biography}>{story.biopgraphy.biopgraphy}</p>
            </div>
          </div>
          <div className={styles.Story__video}>
            {/*<img src={story.interviewVideo.file.url} alt={story.interviewVideo.title} />*/}
            <VimeoEmbed
              url={story.interviewVideoLink}
              poster={ story.interviewVideoPlaceholder ? story.interviewVideoPlaceholder : '' }
              loop={false}
              autoplay={true}
              controls={true}
            />
          </div>
          <div className={styles.Story__quote}>
            <p className={`quote`}>{story.quote.quote}</p>
          </div>
        </div>
      )}
  </div>
)

export default StoryCards;



// WEBPACK FOOTER //
// ./src/components/SuccessStories/StoryCards/index.js